export default __webpack_public_path__ + "static/media/payment_insufficient.70b47176.svg";